import SmartPhoto from "smartphoto";

export default class Sokanzu{

    constructor(){
        this.init();
    }


    init(){
        this._createViewer();
    }


    _createViewer(){

        this.photo = new SmartPhoto('.js-smartPhoto', {
            arrows: false,
            nav: false
        });
    }
}